import { render, staticRenderFns } from "./OrganismLoginCallback.vue?vue&type=template&id=1c103b03"
import script from "./OrganismLoginCallback.vue?vue&type=script&lang=js"
export * from "./OrganismLoginCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports